import axios from "axios";
import querystring from "querystring";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
const token = localStorage.getItem('user-token');
const user = localStorage.getItem('user-id');
if (token && user) {
    axios.defaults.headers.common['X-Authorization'] = 'Bearer ' + token;
    axios.defaults.headers.common['X-User'] = user;
}

const getters = {
    BDDSPFLIST: state => {
        return state.bddspflist;
    },
};
const mutations = {
    SET_BDDSPFLIST: (state, payload) => {
        state.bddspflist = payload;
    },
};
const actions = {
    // eslint-disable-next-line no-unused-vars
    GET_BDDSPFLIST: async (context, payload) => {
        const req = querystring.stringify(payload);
        try {
            let {data} = await axios.get('/budget-api/bddspf/list?' + req);
            context.commit('SET_BDDSPFLIST', data);
            return data;
        } catch (err) {
            return err;
        }
    },
    EXCEL_BDDSPFLIST: async (context, payload) => {
        const req = querystring.stringify(payload);
        try {
            let {data} = await axios.get('/budget-api/bddspf/excellist?' + req);
            return data;
        } catch (err) {
            return err;
        }
    },
};

export default {
    state: () => ({
        bddspflist: null,
    }),
    mutations,
    actions,
    getters
};
